var checkoutConfig = {
    isOneStepCheckout: true,
    editCartFancyboxConfig: {},
    termsFancyboxConfig: {},
    validateProfil: true,
    alwaysValidateProfile: false,
    greekPhoneValidation: true,
    greekMobileValidation: true,
    billingSetAddressEnabled: true,
    billingSetDefaultAddress: true,
    refreshDeliveryPoint: false,
    taxIdentifierDelay: 1000,
    customShippingMethods: {},
    watchParams: {
        shipping: {
            firstName: false,
            lastName: false,
            email: false,
            phone: false,
            mobile: false
        }
    },
    CheckoutStoreMapConfig: function (store) {
        var map = new GMaps({
            div: '#store-map',
            lat: store.Latitude,
            lng: store.Longitude,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            streetViewControl: false,
            mapTypeControl: false,
        });

        map.addMarker({
            lat: store.Latitude,
            lng: store.Longitude,
            icon: "../../../Themes/templateThemeTwo/images/marker_small.png"
        });
        map.setZoom(16);
    },
    InitFancybox: function () {
        $(".terms-link").fancybox(checkoutConfig.termsFancyboxConfig);
    },
};

var checkoutOverrides = {
    Parent: {
        Extend: function (scope) {
            return scope;
        }
    },
    Profile: {
        UpdateOnSubmit: function (orderType, billingAddress, shippingAddress, profile) {
            return profile;
        },
        UpdateOnLoad: function (form, billing) {
            return form;
        }
    },
    DeliveryPoint: {
        IsPointAvailable: function (point) {
            return true;
        }
    },
    Order: {
        ExtendModel: function (order) {
            return {};
        }
    },
    Payment: {
        ExtendControl: function (control, element) {
            return {};
        },
        CheckIfNotAvailable: function (paymentMethodId) {
            return false;
        },

        //GetSelected : function (paymentMethodId, paymentProcessorId, availablePaymentMethodIs, methods, control, order){
        //    return selectedMethod;
        //},

        //IsMethodAvailable: function(method, control, order, shipping){
        //},

        //IsMethodSelected: function(selectedMethodId, selectedProcessorId, method, control, order){
        //    return isSelected;
        //},

        UpdateOnSet: function (model) {
            return model;
        },
        UpdateOnInit: function (model) {
            return model;
        },
        //Validate: function(model, control){
        //    return control.Selected != 0;
        //}, 
        ExtendModel: function (control, order) {
            return {};

        },
        Extend: function (model) {
            return model;
        },
        //ExtraCheckPaymentMethod = function (paymentMethodId, paymentProcessorId, scope) {
        //    return method;
        //}
    },
    Shipping: {
        ExtendModel: function (control, order) {
            return {};

        },
        //CheckOnGetData: function(order){
        //},


        AddWatch: function (scope) {
        },
        //IsOptionAvailable: function (option, control, shipping){
        //},
        //CalculateCompany: function (selected, scope) {

        //}
        UpdateOnSubmit: function (shippingAddress, profile) {
            return shippingAddress;
        },
        //CalculateVisibility: function (scope, method) {
        //}
    },
    Billing: {
        AddWatch: function (scope) {

        },
    },
    Coupon: {
        Extend: function (scope, element) {
            return scope;
        },
        OnGetData: function (scope) { }
    },
    CreditBalance: {
        Extend: function (scope, element) {
            return scope;
        },
        OnGetData: function (scope) { }
    },
    ProductsReviewBox: {
        Extend: function (scope, element) {
            return scope;
        }
    },
    ReviewBox: {
        Extend: function (scope, element) {
            return scope;
        }
    },
    Completion: {
        IniteSatisfaction: function (scope, q) {
            return scope;
        }
    }
};
